<template>
    <div>
        <div class="listing-header mb-4">
            <div class="modal-icons" v-show="hasOcorrenciaSelecionada">
                <svg
                    class="svg-icons"
                    @click="openModal('geral')"
                    :title="$t('geral')"
                >
                    <use
                        :xlink:href="
                            require('@/assets/img/icons/card-reader.svg') +
                            '#layer'
                        "
                    />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('produtos-ocorrencia')"
                    :title="$t('produto')"
                    v-show="ocorrenciaHasProdutos"
                >
                    <use
                        :xlink:href="
                            require('@/assets/img/icons/cash-register.svg') +
                            '#layer'
                        "
                    />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('anexos-ocorrencia')"
                    :title="$t('ocorrencia')"
                    v-show="ocorrenciaHasAnexos"
                >
                    <use
                        :xlink:href="
                            require('@/assets/img/icons/no-image.svg') + '#layer'
                        "
                    />
                </svg>
            </div>

            <div class="title-breadcrumb" />
            <div class="header-buttons" v-if="!cantEdit">
                <button
                    v-if="
                        (!isUpdate && permissao.create) ||
                        (isUpdate && permissao.update)
                    "
                    @click="save(4)"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <vss-select
                        :id="generateId(1)"
                        ref="tipoocorrenciaSelect"
                        title="agro-tipoocorrencia"
                        :options="tipoocorrenciaSelect"
                        v-model="tipoocorrenciaSelected"
                        :required="true"
                        :invalid="tipoocorrenciaSelected == null"
                        :loading="tipoocorrenciaLoading"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit"
                        @onBlurFunction="sendIsChanged('tipoocorrencia')"
                        searchable
                        @search="loadTipoOcorrencia"
                    />
                </div>
                <div class="column is-5">
                    <vss-select
                        :id="generateId(5)"
                        ref="ocorrenciaSelect"
                        title="ocorrencia"
                        :placeholder="
                            ocorrenciaSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :options="ocorrenciaSelect"
                        v-model="ocorrenciaSelected"
                        :required="true"
                        :invalid="ocorrenciaSelected == null"
                        :loading="ocorrenciaLoading"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByTipoocorrencia
                        "
                        @onBlurFunction="sendIsChanged('ocorrencia')"
                        searchable
                        @search="loadOcorrencia"
                    />
                </div>
                <div class="column is-3">
                    <v-money
                        :id="generateId(40)"
                        ref="quebrasafraInput"
                        v-model="agrovisitaitem.quebrasafra"
                        title="quebra-safra"
                        :required="true"
                        :disabled="cantEdit || isLoadingEdit"
                        :msg="invalidQuebrasafraMsg"
                        :invalid="invalidQuebrasafra"
                        @onBlurFunction="validateQuebrasafra()"
                        :min="0"
                        :max="100"
                    />
                </div>
                <div class="column is-12">
                    <v-textarea
                        ref="obscadastral"
                        :id="generateId(50)"
                        v-model="agrovisitaitem.descricao"
                        title="descricao"
                        placeholder="placeholder-preencha"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :disabled="cantEdit || isLoadingEdit"
                        :maxlength="500"
                        :icon="cantEdit ? null : 'text-box-plus-outline'"
                        iconSvg
                        @input-action="showModal = !showModal"
                    />
                </div>
            </div>
        </div>
        <!-- MODAL DE SELEÇÃO -->
        <b-modal :active.sync="showModal" @fecharModal="fecharModal">
            <div class="bg">
                <SugestaoSelectModal
                    @fecharModal="fecharModal"
                    @selected="sugestaoSelected"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
// #71161
import AgroVisitaService from "@/services/agro/agrovisita/AgroVisitaService";
import AgroVisitaItemService from "@/services/agro/agrovisita/AgroVisitaItemService";
import OcorrenciaService from "@/services/agro/ocorrencia/OcorrenciaService";
import TipoOcorrenciaService from "@/services/agro/ocorrencia/TipoOcorrenciaService";
import AgroVisitaItemValidation from "@/services/validations/agro/AgroVisitaItemValidation";
import SugestaoSelectModal from "@/components/agro/agro-visita-item/modal/SugestaoSelectModal";

// Services
import AnexoService from "@/services/agro/ocorrencia/AnexoService";
import AssOcorrenciaProdutoService from "@/services/agro/ocorrencia/AssOcorrenciaProdutoService";

export default {
    components: {
        SugestaoSelectModal,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        tabChanged: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AgroVisitaItemService(this.$http, this.$router),
            serviceOcorrencia: new OcorrenciaService(this.$http, this.$router),
            serviceVisita: new AgroVisitaService(this.$http, this.$router),
            serviceTipoOcorrencia: new TipoOcorrenciaService(
                this.$http,
                this.$router
            ),
            serviceAnexo: new AnexoService(this.$http, this.$router),
            serviceOcorrenciaProduto: new AssOcorrenciaProdutoService(
                this.$http,
                this.$router
            ),

            validation: new AgroVisitaItemValidation(this.$root.msgs),
            agrovisitaitem: {
                idagro_visitaitemerp: null,
                uuid: null,
                uuidagro_visita: null,
                idagro_ocorrencia: null,
                quebrasafra: 0,
                descricao: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                // objeto
                ocorrencia: null,
                agrovisita: null,
            },
            // Controles de TipoOcorrencia
            tipoocorrenciaLoading: true,
            tipoocorrenciaSelect: [],
            tipoocorrenciaSelected: null,
            disabledByTipoocorrencia: true,
            // Controles de Ocorrencia
            ocorrenciaLoading: false,
            ocorrenciaSelect: [],
            ocorrenciaSelected: null,

            invalidQuebrasafra: true,
            invalidQuebrasafraMsg: "msg-campo-obrigatorio",

            isLoading: false,
            isSaving: false,
            
            permissao: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            position: null,
            // Modal
            showModal: false,
            modalManage: false,
            hasOcorrenciaSelecionada: false,
            ocorrenciaHasProdutos: false,
            ocorrenciaHasAnexos: false,
        };
    },
    watch: {
        agrovisitaitem: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChanged", true);
                }
            },
        },
        tabChanged(val) {
            if (val) this.setModalOcorrencia();
        },
    },
    created() {
        setTimeout(() => {
            this.$emit("isChanged", false);
        }, 500);
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-visita",
            "agro-visita"
        );
        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-visita-item" },
            });
        } else {
            this.loadTipoOcorrencia();

            if (this.isUpdate) {
                this.carregarDados();
            } else {
                this.carregarDadosVisita();
            }
        }
    },
    methods: {
        fecharModal() {
            this.showModal = false;
        },
        sugestaoSelected(sugestao) {
            this.agrovisitaitem.descricao = sugestao;
            this.fecharModal();
        },
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },
        carregarDadosVisita() {
            this.isLoading = true;
            this.serviceVisita
                .findByUuid(this.$route.params["idvisita"])
                .then((value) => {
                    this.agrovisitaitem.agrovisita = Object.assign(
                        {},
                        value.content
                    );
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .findByUuid(this.$route.params.id)
                .then((value) => {
                    this.agrovisitaitem = Object.assign({}, value.content);
                    this.$emit(
                        "situacao",
                        this.agrovisitaitem.agrovisita.situacao
                    );
                    this.setModalOcorrencia();
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    if (this.agrovisitaitem.idagro_visitaitemerp != null) {
                        this.$emit(
                            "iderp",
                            this.agrovisitaitem.idagro_visitaitemerp
                        );
                    }
                    this.fillSelected();
                    setTimeout(() => {
                        this.$emit("isChanged", false);
                    }, 500);
                });
        },
        setModalOcorrencia() {
            this.$emit(
                "set-selected-ocorrencia",
                this.agrovisitaitem.ocorrencia.id
            );
            this.getCountProdutosOcorrencia(this.agrovisitaitem.ocorrencia.id);
            this.getCountAnexosOcorrencia(this.agrovisitaitem.ocorrencia.id);
        },
        getCountProdutosOcorrencia(idagro_ocorrencia) {
            this.ocorrenciaHasProdutos = false;
            this.serviceOcorrenciaProduto
                .findAllCount(idagro_ocorrencia)
                .then((body) => {
                    this.ocorrenciaHasProdutos = body.content > 0;
                    this.$emit("set-has-produtos", this.ocorrenciaHasProdutos);
                });
        },
        getCountAnexosOcorrencia(idagro_ocorrencia) {
            this.ocorrenciaHasAnexos = false;
            this.serviceAnexo.findAllCount(idagro_ocorrencia).then((body) => {
                this.ocorrenciaHasAnexos = body.content > 0;
                this.$emit("set-has-anexos", this.ocorrenciaHasAnexos);
            });
        },
        loadTipoOcorrencia(termo = null) {
            this.tipoocorrenciaLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? ".*" : termo,
            ];

            this.serviceTipoOcorrencia
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.id,
                            label: m.descricao,
                            cor: m.cor,
                            icone: m.icone.toLowerCase(),
                        };
                    });
                })
                .then((r) => {
                    this.tipoocorrenciaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.tipoocorrenciaSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.tipoocorrenciaSelected =
                            this.tipoocorrenciaSelect[0];
                        this.sendIsChanged("tipoocorrencia");
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.tipoocorrenciaLoading = false;
                });
        },
        loadOcorrencia(termo = null) {
            this.hasOcorrenciaSelecionada = false;
            if (this.tipoocorrenciaSelected == null) {
                this.ocorrenciaLoading = false;
                return;
            }
            this.ocorrenciaLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? ".*" : termo,
                // Id da cultura caso tenha
                this.agrovisitaitem.agrovisita.cultura != null &&
                this.agrovisitaitem.agrovisita.cultura.id
                    ? this.agrovisitaitem.agrovisita.cultura.id
                    : null,
                // parâmetro adicional com o nome do que deve ser filtrado
                this.tipoocorrenciaSelected != null &&
                this.tipoocorrenciaSelected.id
                    ? "tipoocorrencia"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.tipoocorrenciaSelected != null &&
                this.tipoocorrenciaSelected.id
                    ? this.tipoocorrenciaSelected.id
                    : null,
            ];

            this.serviceOcorrencia
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.nomepopular,
                        };
                    });
                })
                .then((r) => {
                    this.ocorrenciaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.ocorrenciaSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.ocorrenciaSelected = this.ocorrenciaSelect[0];
                        this.hasOcorrenciaSelecionada = true;
                        this.sendIsChanged("ocorrencia");
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.ocorrenciaLoading = false;
                });
        },
        successPosition(position) {
            this.agrovisitaitem.latitude = position.coords.latitude
                ? position.coords.latitude
                : 0;
            this.agrovisitaitem.longitude = position.coords.longitude
                ? position.coords.longitude
                : 0;
            this.agrovisitaitem.lastfix = position.timestamp
                ? position.timestamp
                : null;
            this.agrovisitaitem.tipogps = position.coords.latitude ? 1 : 0;
            console.info(position);
        },
        errorPosition(e) {
            console.error("Geolocation error!", e);
        },
        save() {
            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                console.log("Geolocation is supported by this browser");
                navigator.geolocation.getCurrentPosition(
                    this.successPosition,
                    this.errorPosition
                );
            } else {
                console.log("Geolocation is not supported by this browser");
            }
            setTimeout(() => {
                // faz a cópia dos dados para não afetar os originais caso de erro
                let agrovisitaitemTemp = Object.assign({}, this.agrovisitaitem);
                agrovisitaitemTemp.idagro_ocorrencia =
                    this.ocorrenciaSelected != null
                        ? this.ocorrenciaSelected.id
                        : null;
                agrovisitaitemTemp.uuidagro_visita =
                    this.$route.params["idvisita"];

                // passa os dados para a validação
                if (
                    this.validation.validate(
                        agrovisitaitemTemp,
                        this.tipoocorrenciaSelected,
                        this.$refs
                    )
                ) {
                    agrovisitaitemTemp = this.mapTosave(agrovisitaitemTemp);

                    this.isSaving = true;
                    this.service
                        .save(agrovisitaitemTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msg = this.$t(
                                        this.isUpdate
                                            ? "msg-edit-sucesso-n"
                                            : "msg-save-sucesso-n", 
                                        { n: this.$t("agro-visita-item") }
                                    );

                                this.$root.showMessage(
                                    "success",
                                    msg,
                                    true,
                                    false
                                );

                                // redireciona para a tela de ...... caso venha de lá
                                if (this.$route.query.tela) {
                                    this.redirectToPage();
                                } else if (this.$route.params.id) {
                                    this.carregarDados();
                                } else {
                                    // manda para a edição para adicionar os items
                                    this.redirectToEdit(value.content.uuid);
                                }
                                this.$emit("isChanged", false);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage(
                                        "alert",
                                        value.message,
                                        true
                                    );
                                } else {
                                    this.$root.showMessage(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    );
                                }
                            }
                        })
                        .catch((e) => {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            );
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                        });
                } else {
                    this.$root.showMessage(
                        "alert",
                        "msg-campos-obrigatorios",
                        true
                    );
                    this.isLoading = false;
                }
            }, 300);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: "agro-visita-item-edit",
                    params: { id: id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == "agro-visita-item") {
                tempTela = "agro-visita-item-edit";
                tempAba = "empresa";
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query["id"] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
        fillSelected() {
            if (this.isUpdate && this.isLoadingEdit) {
                // preenche a ocorrência
                if (
                    this.agrovisitaitem.ocorrencia &&
                    !this.isNull(this.agrovisitaitem.ocorrencia.nomepopular)
                ) {
                    this.ocorrenciaSelected = {
                        id: this.agrovisitaitem.ocorrencia.id,
                        label:
                            this.agrovisitaitem.ocorrencia.nomepopular +
                            " - " +
                            this.agrovisitaitem.ocorrencia.nomecientifico,
                    };
                    // preenche o tipo da ocorrência
                    if (
                        this.agrovisitaitem.ocorrencia.agroTipoOcorrencia &&
                        !this.isNull(
                            this.agrovisitaitem.ocorrencia.agroTipoOcorrencia
                                .descricao
                        )
                    ) {
                        this.tipoocorrenciaSelected = {
                            id: this.agrovisitaitem.ocorrencia
                                .agroTipoOcorrencia.id,
                            label: this.agrovisitaitem.ocorrencia
                                .agroTipoOcorrencia.descricao,
                            cor: this.agrovisitaitem.ocorrencia
                                .agroTipoOcorrencia.cor,
                            icone: this.agrovisitaitem.ocorrencia.agroTipoOcorrencia.icone.toLowerCase(),
                        };
                    }
                }
                // avisa que o carregamento da página acabou na edição
                setTimeout(() => {
                    this.isLoadingEdit = false;
                }, 1500);
            }
        },
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.$emit("isChanged", true);

            // Já aproveita e faz as validações
            // console.log("alterou", label);
            setTimeout(() => {
                if (label == "tipoocorrencia") {
                    if (!this.isLoadingEdit) {
                        this.ocorrenciaSelected = null;
                        this.hasOcorrenciaSelecionada = false;
                    }

                    if (
                        this.tipoocorrenciaSelected != null &&
                        this.tipoocorrenciaSelected.id
                    ) {
                        this.disabledByTipoocorrencia = false;
                        // carrega select dependente
                        this.loadOcorrencia();
                    } else {
                        this.disabledByTipoocorrencia = true;
                    }
                } else if (
                    label == "ocorrencia" &&
                    this.ocorrenciaSelected != null &&
                    this.ocorrenciaSelected.id > 0
                ) {
                    this.hasOcorrenciaSelecionada = true;
                    this.getCountProdutosOcorrencia(this.ocorrenciaSelected.id);
                    this.getCountAnexosOcorrencia(this.ocorrenciaSelected.id);
                }
            }, 200);
        },
        openModal(buttonClicked) {
            let info = {
                buttonClicked: buttonClicked,
                ocorrenciaId: this.ocorrenciaSelected.id,
            };
            this.$emit("open-modal-info-ocorrencia", info);
        },
        validateQuebrasafra() {
            if (this.isNull(this.agrovisitaitem.quebrasafra)) {
                this.invalidQuebrasafra = true;
                this.invalidQuebrasafraMsg = "msg-campo-obrigatorio";
            } else if (
                !this.validatePorcentagem(+this.agrovisitaitem.quebrasafra)
            ) {
                this.invalidQuebrasafra = true;
                this.invalidQuebrasafraMsg = "msg-campo-invalido";
            } else {
                this.invalidQuebrasafra = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
.modal-icons {
    .svg-icons {
        margin-right: 5px;
        width: 35px;
        height: 35px;
        fill: $semi-title-color;
        cursor: pointer;
    }
}
</style>